<template>
  <div>
    <loading :showLoading="load" />
    <div class="Create alignment">
      <h3 v-if="isEdit" class="styleHeader" style="margin-bottom: 31px">
        {{ $t("Request.Edit") }}
      </h3>
      <h3 v-else class="styleHeader" style="margin-bottom: 31px">
        {{ $t("Request.Add") }}
      </h3>
      <v-form ref="form" v-model="valid" style="height: 100%">
        <v-card class="styleDataTable border">
          <template>
            <v-container fluid>
              <v-row dense>
                <v-col>
                  <v-text-field v-model="userDivisionDescription" :label="$t('Request.DivisionDescription')"
                    disabled></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field v-model="userBUDescription" :label="$t('Request.BUDescription')" disabled></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field v-model="userCompanyDescription" :label="$t('Request.CompanyDescription')"
                    disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-select v-model="statusSelected" :items="statuses" item-text="description" item-value="id"
                    :label="$t('Request.Status')" :disabled="!isAdmin || !isEdit"
                    :rules="[rules.mandatoryRule]"></v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field v-model="title" :label="$t('Request.Title')" required :rules="[rules.mandatoryRule]"
                    :disabled="isEdit">
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-checkbox v-model="isExternalCompany" :label="$t('Request.IsExternalCompany')"
                    :disabled="isEdit"></v-checkbox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field v-model="shipmentNumber" :label="$t('Request.ShipmentNumber')" required
                    :rules="[rules.mandatoryRule]" :disabled="isEdit"></v-text-field>
                </v-col>
                <v-col v-if="isExternalCompany">
                  <v-autocomplete v-model="externalCompanySelected" :items="companies" item-value="Id" item-text="Name"
                    :label="$t('Request.ExternalCompany')" :rules="externalCompanyRule"
                    :disabled="isEdit"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field v-model="sender" :label="$t('Request.Sender')" required :rules="[rules.mandatoryRule]"
                    :disabled="isEdit"></v-text-field>
                </v-col>
                <v-col>
                  <v-combobox v-model="carriersCodeListSelected" :items="carriersCodeList"
                    :label="$t('Request.CarriersCodeList')" multiple :rules="[rules.mandatoryRule]"
                    :disabled="isEdit"></v-combobox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-autocomplete v-model="selectedSenderCountry" :items="states" item-value="Id" item-text="CommonName"
                    :label="$t('Request.SenderCountry')" :rules="[rules.mandatoryRule]"
                    :disabled="isEdit"></v-autocomplete></v-col>
                <v-col>
                  <v-combobox v-model="vehiclesTypeListSelected" :items="vehiclesTypeList"
                    :label="$t('Request.VehiclesCodeList')" item-value="id" item-text="description" multiple
                    :rules="[rules.mandatoryRule]"></v-combobox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field v-model="recipient" :label="$t('Request.Recipient')" required
                    :rules="[rules.mandatoryRule]" :disabled="isEdit"></v-text-field>
                </v-col>
                <v-col>
                  <v-select v-model="categorySelected" :items="categories" item-text="languageName" item-value="id"
                    :label="$t('Request.Category')" :rules="[rules.mandatoryRule]" :disabled="isEdit"></v-select>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-autocomplete v-model="selectedRecipientCountry" :items="states" item-value="Id"
                    item-text="CommonName" :label="$t('Request.RecipientCountry')" :rules="[rules.mandatoryRule]"
                    :disabled="isEdit"></v-autocomplete></v-col>
                <v-col>
                  <v-text-field v-model="grossWeight" :label="$t('Request.GrossWeight')" :rules="[rules.threeDecimalRule]"
                    :disabled="isEdit" type="number"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateFormatted" :label="$t('Request.DateTransport')" hint="MM/DD/YYYY"
                        persistent-hint v-bind="attrs" @blur="date = parseDate(dateFormatted)" v-on="on" required
                        :rules="[rules.mandatoryRule]" :disabled="isEdit"></v-text-field>
                    </template>
                    <v-date-picker v-model="dateTransport" no-title @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-text-field v-model="valueItem" :label="$t('Request.Value')" :rules="[rules.twoDecimalRule]"
                    type="number"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field v-model="valueGuaranteed" :label="$t('Request.ValueGuaranteed')" required
                    :rules="[rules.twoDecimalRule]" type="number"></v-text-field>
                </v-col>
                <v-col>
                  <v-select v-model="warrantySelected" :items="warranties" item-text="description" item-value="id"
                    :label="$t('Request.Warranty')" :rules="[rules.mandatoryRule]" :disabled="isEdit"></v-select>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-card>
        <v-btn class="white--text styleButtonTop styleAlignementSaveButton border" @click="save()" color="black">
          <v-icon left>fas fa-check-circle</v-icon>
          {{ $t("SearchMenu.Button.Save") }}
        </v-btn>
        <v-btn class="styleButtonTop border" @click="back()">
          <v-icon left>fas fa-times-circle</v-icon>
          {{ $t("SearchMenu.Button.Cancel") }}
        </v-btn>
      </v-form>

      <v-snackbar v-model="showErr" color="error" :timeout="snackbarTimeout">
        {{ textErr }}
        <v-btn color="white" text @click="showErr = false">
          {{ $t("Misc.Close") }}
        </v-btn>
      </v-snackbar>
    </div>

    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>{{ dialogMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text styleButtonTop styleAlignementSaveButton border" @click="closeDialog()" color="black">
            <v-icon left>fas fa-check-circle</v-icon>
            {{ $t("SearchMenu.Button.Ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import loading from "../../components/loadingComponent.vue";
import { Trans } from "@/plugins/Translation";
import BackEndApi from "../../api/AllRisk/allRiskApi.js";
import IMApi from "../../api/IM/IMApi.js";
import router from "@/router/index.js";
import allRiskApi from "../../api/AllRisk/allRiskApi.js";
import emailSenderApi from "../../api/EmailSender/emailSenderApi.js";
import moment from "moment";

export default {
  components: { loading },

  data: (vm) => ({
    load: false,
    showErr: false,
    textErr: "",
    valid: false,
    isEdit: false,
    isAdmin: false,
    loggedUsername: "",
    snackbarTimeout: 4000,
    dialog: false,
    dialogMessage: "",
    dialogHasTobeShown: false,
    sendMail: false,
    mailText: "",
    mailSubject: "",
    mailTos: [],
    mailCCs: [],
    legalRepresentantEmail: "",

    // constant
    grossWeightBUName: "DIN",
    valueGuaranteedMaxValue: 150000,
    valueMaxValue: 150000,
    valueGuaranteedPercentage: 10,
    maxValue: 50.0,

    // statuses
    statusExpired: 5,
    statusToBeChecked: 2,
    statusValid: 3,
    statusRefused: 4,
    statusNew: 1,

    // warranties
    warrantiesCheck: [5, 6],

    // model
    title: "",
    shipmentNumber: "",
    sender: "",
    states: [],
    selectedSenderCountry: null,
    recipient: "",
    selectedRecipientCountry: null,
    dateTransport: "",
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    isExternalCompany: false,
    externalCompanySelected: "",
    companies: [],
    carriersCodeList: [],
    carriersCodeListSelected: "",
    vehiclesTypeList: [],
    vehiclesTypeListSelected: "",
    categories: [],
    categorySelected: "",
    grossWeight: 0.0,
    valueItem: 0.0,
    valueGuaranteed: 0.0,
    warranties: [],
    warrantySelected: "",
    branchid: 0,
    buid: 0,
    statusSelected: "",
    statuses: [],
    dateUpdated: "",
    guid: "00000000-0000-0000-0000-000000000000",
    username: "",
    branch: "",
    branchList: [],
    bu: "",
    buList: [],
    companyList: [],
    dateCreated: "",
    adUserBranchId: "",
    adUserBUId: "",
    adUserDivisionId: "",
    userBUDescription: "",
    userDivisionDescription: "",
    userCompanyDescription: "",

    //mandatoryRule: [(v) => !!v || Trans.i18n.t("Validations.Mandatory")]
    // validation rules
    rules: {
      mandatoryRule: (value) =>
        !!value || Trans.i18n.t("Validations.Mandatory"),
      twoDecimalRule: (value) => {
        const pattern = /^(\d{1,}|\d{1,}.\d{1,2})$/;

        return (
          pattern.test(value) ||
          Trans.i18n.t("Validations.FormatRequestedTwoDecimal")
        );
      },
      threeDecimalRule: (value) => {
        const pattern = /^(\d{1,}|\d{1,}.\d{1,3})$/;

        return (
          pattern.test(value) ||
          Trans.i18n.t("Validations.FormatRequestedThreeDecimal")
        );
      },
    },
  }),

  computed: {
    externalCompanyRule() {
      const rules = [];

      if (this.isExternalCompany) {
        const rule = (v) => !!v || Trans.i18n.t("Validations.Mandatory");
        rules.push(rule);
      }
      return rules;
    },
  },

  watch: {
    dateTransport(val) {
      this.dateFormatted = this.formatDate(this.dateTransport);
    },

    '$store.getters.GET_languageChanged': function () {

      for (let i = 0; i < this.categories.length; i++) {
        var category = this.categories[i];
        category.languageName = Trans.currentLanguage == "it" ? category.name : category.nameEn;
      }
      //dropdown refresh
      var tmp = this.categorySelected;
      this.categorySelected = "";
      this.categorySelected = tmp;

      for (let i = 0; i < this.statuses.length; i++) {
        this.statuses[i].description = Trans.i18n.t("Status." + this.statuses[i].id)
      }

      for (let i = 0; i < this.warranties.length; i++) {
        this.warranties[i].description = Trans.i18n.t("Warranties." + this.warranties[i].id)
      }

      for (let i = 0; i < this.vehiclesTypeList.length; i++) {
        this.vehiclesTypeList[i].description = Trans.i18n.t("VehiclesTypes." + this.vehiclesTypeList[i].id)
      }
    }

  },

  async created() {
    this.load = true;
    this.snackbarTimeout = 4000;
    const id = this.$route.params.Id;

    // only ad user can be access
    let aduserInfo_res = await IMApi.GetADUserInformationByUsername(
      this.$GAUserAuth.user.username
    );
    if (!aduserInfo_res.data) {
      this.$router.push({ name: "unauthorized" });
    }

    // console.log("getaduser", aduserInfo_res);

    this.isAdmin = this.$GAUserAuth.isAdmin();
    // this.isAdmin=false;
    this.loggedUsername = this.$GAUserAuth.user.username;

    this.adUserBranchId = aduserInfo_res.data.BranchId;
    this.adUserBUId = aduserInfo_res.data.BUId;

    this.adUserDivisionId = aduserInfo_res.data.DivisionId;

    this.userCompanyDescription = aduserInfo_res.data.Company;

    let division_res = await IMApi.GetDivisionWithDirector(
      this.adUserDivisionId
    );
    // console.log("division", division_res);
    if (division_res.data) {
      // set current user division as default
      this.userDivisionDescription = division_res.data.d
        ? division_res.data.d.Description
        : "";
    }

    let legal_arg = {
      JobTitleId: process.env.VUE_APP_DIRECTOR_JOBTITLE_ID,
      JobTitleName: process.env.VUE_APP_DIRECTOR_JOBTITLE,
    };
    let legalrepresentant_res = await IMApi.GetLegalRepresentant(legal_arg);
    this.legalRepresentantEmail = legalrepresentant_res.data.Email;
    // console.log("legal", legalrepresentant_res.data, this.legalRepresentantEmail, legal_arg);

    let states_res = await IMApi.GetStates();
    this.states = states_res.sort(function (a, b) {
      if (a.CommonName < b.CommonName) {
        return -1;
      }
      if (a.CommonName > b.CommonName) {
        return 1;
      }
      return 0;
    });
    //console.log("states", this.states);

    let companies_res = await IMApi.GetExternalCompanies();
    this.companies = companies_res;
    //console.log("companies", this.companies);

    let categories_res = await BackEndApi.GetCategoriesList();
    if (id) {
      this.categories = categories_res.data;
    } else {
      this.categories = categories_res.data.filter((x) => x.enable);
    }

    //use correct language for categories
    for (let i = 0; i < this.categories.length; i++) {
      var category = this.categories[i];
      category.languageName = Trans.currentLanguage == "it" ? category.name : category.nameEn;
    }

    var userBuId = null;
    if (!id)
      userBuId = this.adUserBUId;

    let warranties_res = await BackEndApi.GetWarranties(userBuId);
    this.warranties = warranties_res.data;
    for (let i = 0; i < this.warranties.length; i++) {
      this.warranties[i].description = Trans.i18n.t("Warranties." + this.warranties[i].id)
    }
    // console.log("warranties", this.warranties, "user buid", this.adUserBUId);

    let statuses_res = await BackEndApi.GetStatuses(true);
    this.statuses = statuses_res.data;
    for (let i = 0; i < this.statuses.length; i++) {
      this.statuses[i].description = Trans.i18n.t("Status." + this.statuses[i].id)
    }

    let vehiclestypes_res = await BackEndApi.GetVehiclesTypes();
    this.vehiclesTypeList = vehiclestypes_res.data;
    for (let i = 0; i < this.vehiclesTypeList.length; i++) {
      this.vehiclesTypeList[i].description = Trans.i18n.t("VehiclesTypes." + this.vehiclesTypeList[i].id)
    }

    let bu_res = await IMApi.GetBU();
    this.buList = bu_res.Data;

    let branch_res = await IMApi.GetBranches();
    this.branchList = branch_res;

    let companyList_res = await IMApi.GetCompanies();
    this.companyList = companyList_res;

    // set current user bu as default
    this.userBUDescription =
      this.buList.filter((x) => x.Id == this.adUserBUId).length > 0
        ? this.buList.filter((x) => x.Id == this.adUserBUId)[0].Description
        : "";

    // console.log("bu desc", this.userBUDescription);

    // let division_res = await IMApi.GetDivisions();
    // this.divisionList = division_res.Data;

    if (id) {
      this.$store.commit("SET_requestAdded", false);
      // console.log("EDIT", this.$store.getters.GET_requestAdded);

      this.isEdit = true;
      BackEndApi.GetRequest(id)
        .then((response) => {
          //   console.log("request", response.data);

          this.username = response.data.username;

          //console.log("logged", this.loggedUsername, "username", this.username);
          // base user can view only theirs requests
          if (this.loggedUsername != this.username) {
            if (!this.isAdmin) {
              this.$router.push({ name: "unauthorized" });
            }
          }

          // "new" status can be selected only if the request has "new" status
          if (response.data.statusId != this.statusNew) {
            this.statuses = this.statuses.filter(function (el) {
              return el.id !== 1;
            });
          }

          // "expired" status can't be selected
          this.statuses = this.statuses.filter(function (el) { return el.id !== 5; });

          this.title = response.data.title;
          this.shipmentNumber = response.data.shipmentNumber;
          this.sender = response.data.sender;
          this.selectedSenderCountry = this.states.find(
            (x) => x.Id == response.data.senderCountryId
          );
          this.recipient = response.data.recipient;
          this.selectedRecipientCountry = this.states.find(
            (x) => x.Id == response.data.recipientCountryId
          );
          this.dateTransport = this.parseDate(
            moment(response.data.dateTransport).format("DD/MM/YYYY")
          );
          this.isExternalCompany = response.data.isExternalCompany;
          this.carriersCodeListSelected = response.data.carriersCodeList
            .split(";")
            .filter((item) => item);

          let vehicles_list_remote = response.data.vehiclesTypesList
            .split(";")
            .filter((item) => item);
          let saved_vehiclestypes_list = [];
          this.vehiclesTypeList.forEach((element) => {
            if (
              vehicles_list_remote.filter((x) => x == element.description)
                .length > 0
            ) {
              saved_vehiclestypes_list.push(element);
            }
          });
          this.vehiclesTypeListSelected = saved_vehiclestypes_list;

          this.categorySelected = this.categories.find(
            (x) => x.id == response.data.categoryId
          );
          this.grossWeight = response.data.grossWeight;
          this.valueItem = response.data.value;
          this.valueGuaranteed = response.data.valueGuaranteed;
          this.warrantySelected = this.warranties.find(
            (x) => x.id == response.data.warrantyId
          );

          this.currency = "EUR";
          this.branchid = response.data.branchId;
          this.buid = response.data.buId;
          this.externalCompanySelected = this.companies.find(
            (x) => x.Id == response.data.externalCompanyId
          );
          this.statusSelected = this.statuses.find(
            (x) => x.id == response.data.statusId
          );
          this.originalRequestStatus = this.statusSelected;
          this.dateUpdated = response.data.dateUpdated;
          this.guid = response.data.guid;
          this.dateCreated = moment(response.data.dateCreated).format(
            "DD/MM/YYYY"
          );

          this.branch = this.branchList.find((x) => x.Id == this.branchid);
          this.bu = this.buList.find((x) => x.Id == this.buid);
          //   console.log("bu", this.bu);

          this.userBUDescription = this.bu ? this.bu.Description : "";

          if (this.branch) {
            var branchCompany = this.companyList.find((x) => x.Id == this.branch.IdCompanies);
            this.userCompanyDescription = branchCompany ? branchCompany.Name : "";
          }

          if (this.bu) {
            IMApi.GetDivisionWithDirector(this.bu.DivisionId).then(
              (division_res) => {
                this.userDivisionDescription = division_res.data.d.Description;
              }
            );
          }

          this.load = false;
        })
        .catch((e) => {
          this.showErr = true;
          //this.textErr = e.response ? e.response.data : e;
          this.textErr = e.response.data;
          this.load = false;
        });
    } else {
      this.$store.commit("SET_requestAdded", true);
      // console.log("NEW", this.$store.getters.GET_requestAdded);
      this.statusSelected = this.statuses.find((x) => x.id == 1);
      this.username = this.$GAUserAuth.user.username;
      //   console.log("username", this.username);
    }
    this.load = false;
  },
  methods: {
    checkIsExternal() {
      return this.isExternalCompany;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    back() {
      router.push({ name: "home" });
    },

    forceStatusToBeToValidate() {
      // if new request always set to "to be checked"
      if (!this.$route.params.Id) return true;
      // if request in edit set "to be checked" only for non admin users
      if (this.$route.params.Id && !this.isAdmin) return true;
      return false;
    },
    async getDivisionDirectorFromUsername(username) {
      let directorEmail = "";
      let aduserInfo_res = await IMApi.GetADUserInformationByUsername(username);
      //console.log("aduserInfo_res", aduserInfo_res.data);
      let adUserDivisionId = aduserInfo_res.data.DivisionId;

      let division_res = await IMApi.GetDivisionWithDirector(adUserDivisionId);
      //console.log("division", division_res.data);
      if (division_res.data) {
        directorEmail = division_res.data.us ? division_res.data.us.Email : "";
      }
      return directorEmail;
    },
    async getBUDirector(buId, jobTitleId) {
      let aduserInfo_res = await IMApi.GetBUDirectorByJobTitleId(buId, jobTitleId);
      let directorEmail = aduserInfo_res.data ? aduserInfo_res.data.Email : "";
      return directorEmail;
    },
    async save() {
      this.dialogHasTobeShown = false;
      this.sendMail = false;
      var isValid = this.$refs.form.validate();
      //   console.log("is valid", isValid);

      //   console.log(
      //     "c1",
      //     this.selectedSenderCountry,
      //     "c2",
      //     this.selectedRecipientCountry
      //   );

      // a new request starts always as valid
      if (!this.$route.params.Id) {
        this.statusSelected = this.statuses.find(
          (x) => x.id == this.statusValid
        );
      }

      if (isValid) {
        // console.log("status", this.statusSelected);

        // silent validation only if the status is not refused
        var status = this.statusSelected.id
          ? this.statusSelected.id
          : this.statusSelected;
        if (status != this.statusRefused) {
          await this.CheckSilentValidation();
        }

        // console.log("status", status);

        var request = {
          id: this.$route.params.Id,
          title: this.title,
          shipmentNumber: this.shipmentNumber,
          sender: this.sender,
          senderCountryId: this.selectedSenderCountry.Id
            ? this.selectedSenderCountry.Id
            : this.selectedSenderCountry,
          recipient: this.recipient,
          recipientCountryId: this.selectedRecipientCountry.Id
            ? this.selectedRecipientCountry.Id
            : this.selectedRecipientCountry,
          dateTransport: moment(
            this.dateFormatted + " 08:00",
            "DD/MM/YYYY hh:mm"
          ).toISOString(),
          isExternalCompany: this.isExternalCompany,
          carriersCodeList: this.carriersCodeListSelected.join(";"),
          vehiclesTypesList: this.vehiclesTypeListSelected
            .map((x) => x.description)
            .join(";"),
          categoryId: this.categorySelected.id
            ? this.categorySelected.id
            : this.categorySelected,
          grossWeight: this.grossWeight,
          value: this.valueItem,
          valueGuaranteed: this.valueGuaranteed,
          warrantyId: this.warrantySelected.id
            ? this.warrantySelected.id
            : this.warrantySelected,
          username: this.$GAUserAuth.user.username,
          currency: "EUR",
          branchid: this.adUserBranchId,
          buid: this.adUserBUId,
          guid: this.guid,
          externalCompanyId: this.externalCompanySelected
            ? this.externalCompanySelected.Id
              ? this.externalCompanySelected.Id
              : this.externalCompanySelected
            : null,
          statusId: this.statusSelected.id
            ? this.statusSelected.id
            : this.statusSelected,
        };

        // console.log("request", request);

        // check custom validation only if the status is not refused
        if (status != this.statusRefused) {
          if (!this.CheckValidation()) return;
        }

        if (!this.isAdmin && this.dateUpdated) {
          this.showErr = true;
          this.textErr = Trans.i18n.t("Validations.SingleUpdate");
        } else {
          allRiskApi
            .AddRequest(request)
            .then((response) => {
              //   console.log("addrequest result", response.data);
              if (response.data.ok) {
                if (this.sendMail) {
                  var requestId = response.data.request.id;
                  var requestGuid = response.data.request.guid;

                  this.mailSubject = this.mailSubject.replace("{shipmentnumber}", this.shipmentNumber);

                  // console.log("this.shipmentNumber", this.shipmentNumber, "this.mailSubject", this.mailSubject);

                  this.mailText = this.mailText.replace("{id}", requestId).replace("{guid}", requestGuid);
                  //link alla richiesta 
                  var base64Id = "$" + btoa(requestId);
                  var requestLink = process.env.VUE_APP_ALLRISK_LINK_URL + "/" + this.$route.params.lang + "/details/" + base64Id;
                  this.mailText += "<br><br>Request reference: " + requestLink;

                  emailSenderApi.SendMail(this.mailSubject, this.mailTos, this.mailCCs, this.mailText);
                }

                if (this.dialogHasTobeShown) {
                  this.dialogMessage = this.dialogMessage.replace("{id}", requestId).replace("{guid}", requestGuid);
                  this.dialog = true;
                } else {
                  router.push({ name: "RequestCompleted" });
                }
              } else {
                this.showErr = true;
                this.textErr = Trans.i18n.t("Errors.GenericError");
              }
            })
            .catch((e) => {
              console.log("addrequest result", e.response);
              this.showErr = true;
              this.textErr = e.response.data.Message;
            });
        }
      }
    },

    CheckValidation() {
      this.showErr = false;
      this.snackbarTimeout = 30000;

      let result = this.CheckTransportDate();
      if (result) {
        result = this.CheckCountry();
        if (result) {
          result = this.CheckCategory();
        }
      }

      return result;
    },

    async CheckSilentValidation() {
      // check if a dialog is needed, mail must be sent and change status if needed
      this.CheckExternalCompany();
      this.CheckGrossWeight();
      await this.CheckValueGuaranteed();
      this.CheckWarranty();
      this.CheckRefused();
    },

    CheckTransportDate() {
      var dateValid = false;
      var now = moment().startOf("day");
      var dtTransport = moment(this.dateFormatted, "DD/MM/YYYY");
      var duration = moment.duration(dtTransport.diff(now));
      var days = duration.asDays();

      //   console.log("now", now, "dtTransport", dtTransport, "day", days);

      if (this.$route.params.Id) {
        //In modifica di una richiesta
        if (this.isAdmin) { //utente amministratore

          let statusSelectedId = this.statusSelected.id ? this.statusSelected.id : this.statusSelected;

          if (this.originalRequestStatus.id == this.statusToBeChecked && statusSelectedId == this.statusValid) {
            //validazione di una richiesta --> fino a 5 giorni dopo la data di spedizione
            if (days >= -5) { dateValid = true; }
          }
          else if (statusSelectedId == this.statusToBeChecked) {
            //modifica richiesta da confermare --> sempre
            dateValid = true;
          }
          else {
            //negli altri casi solo fino alla data di spedizione
            if (days >= 0) { dateValid = true; }
          }
        }
        else {
          //utente normale --> modifica entro il giorno di spedizione
          if (days >= 0) { dateValid = true; }
        }
      }
      else {
        //In creazione di richiesta --> inserimento nuove richieste solo fino al giorno di partenza della spedizione compreso
        if (days >= 0) { dateValid = true; }
      }

      if (!dateValid) {
        this.showErr = true;
        this.textErr = Trans.i18n.t("Validations.DateTransport");
      }

      return dateValid;
    },

    CheckCountry() {
      let senderCountry = this.selectedSenderCountry.Id
        ? this.selectedSenderCountry
        : this.states.find((x) => x.Id == this.selectedSenderCountry);
      let recipientCountry = this.selectedRecipientCountry.Id
        ? this.selectedRecipientCountry
        : this.states.find((x) => x.Id == this.selectedRecipientCountry);

      //   console.log(
      //     "catselected",
      //     this.categorySelected,
      //     "sender country",
      //     senderCountry,
      //     "recipient country",
      //     recipientCountry
      //   );

      if (senderCountry.AllRiskDenied || recipientCountry.AllRiskDenied) {
        this.showErr = true;
        this.textErr = Trans.i18n.t("Validations.CountryDenied");
        // console.log("CheckCountry1 true");
        return false;
      } else {
        // "ITA;AUT"
        let countryPenalty =
          this.categorySelected.countryPenalty ||
            this.categorySelected.countryPenalty == ""
            ? this.categorySelected.countryPenalty
            : this.categories.find((x) => x.id == this.categorySelected)
              .countryPenalty;

        let countryPenaltyArray = countryPenalty.split(";");

        if (
          countryPenaltyArray.indexOf(senderCountry.LetterCode3) > -1 ||
          countryPenaltyArray.indexOf(recipientCountry.LetterCode3) > -1
        ) {
          this.showErr = true;
          this.textErr = Trans.i18n.t("Validations.CountryRisky");
          //   console.log(
          //     "CheckCountry2 true",
          //     "cat selected",
          //     this.categorySelected,
          //     "country penalty",
          //     countryPenalty
          //   );
          return false;
        }
      }

      // console.log("selected country",this.selectedSenderCountry.AllRiskDenied);

      return true;
    },

    CheckExternalCompany() {
      if (this.isExternalCompany && this.externalCompanySelected) {
        // set to "da controllare"
        if (this.forceStatusToBeToValidate()) {
          this.statusSelected = this.statuses.find(
            (x) => x.id == this.statusToBeChecked
          );
        }
        this.dialogMessage = Trans.i18n.t("Validations.ExternalCompany");
        this.dialogHasTobeShown = true;
        this.sendMail = true;
        this.ConstructEmail(
          Trans.i18n.t("Validations.ExternalCompanySubject"),
          Trans.i18n.t("Validations.ExternalCompany"),
          [this.$GAUserAuth.user.email, process.env.VUE_APP_EMAIL],
          []
        );

        // console.log("CheckExternalCompany true");
        return true;
      }
      return false;
    },

    CheckCategory() {
      let isRisk = false;

      if (this.$route.params.Id) {
        isRisk = this.categorySelected.isRisk;
      } else {
        isRisk = this.categories.find(
          (x) => x.id == this.categorySelected
        ).isRisk;
      }

      //   console.log(
      //     "catsel",
      //     this.categorySelected,
      //     this.categorySelected.isRisk,
      //     "isRisk",
      //     isRisk
      //   );

      if (isRisk) {
        this.showErr = true;
        this.textErr = Trans.i18n.t("Validations.Category");
        // console.log("CheckCategory true");
        return false;
      }
      return true;
    },

    CheckGrossWeight() {
      //   console.log(
      //     "adUserBUId",
      //     this.adUserBUId,
      //     "value",
      //     this.valueItem,
      //     "bulist",
      //     this.buList.find((x) => x.Id == this.adUserBUId).Name
      //   );
      if (
        this.buList.find((x) => x.Id == this.adUserBUId).Name ==
        this.grossWeightBUName &&
        this.valueItem > this.maxValue
      ) {
        this.dialogMessage = Trans.i18n.t("Validations.GrossWeight");
        this.dialogHasTobeShown = true;
        // console.log("CheckGrossWeight true");
        return true;
      }
      return false;
    },

    async CheckValueGuaranteed() {
      if (
        this.valueGuaranteed > this.valueGuaranteedMaxValue ||
        Math.round(this.valueItem * (1 + 0.1) * 100) / 100 <
        this.valueGuaranteed ||
        this.valueItem > this.valueMaxValue
      ) {
        this.dialogMessage = Trans.i18n.t("Validations.ValueGuaranteed");
        this.dialogHasTobeShown = true;
        // set to "da controllare"
        if (this.forceStatusToBeToValidate()) {
          this.statusSelected = this.statuses.find(
            (x) => x.id == this.statusToBeChecked
          );
        }

        // [ticket 225591]
        //if (this.$GAUserAuth.user.email != "Federico.Groppelli@fercam.com") {

        //non invio la mail se la richiesta è stata validata dall'admin       
        this.sendMail = (this.statusSelected == this.statusValid) ? false : true;
        this.dialogHasTobeShown = (this.statusSelected == this.statusValid) ? false : true;

        let divisionDirectorEmail = await this.getDivisionDirectorFromUsername(this.username);
        let directorEmail = divisionDirectorEmail;

        //se la BU è 'Freight Management Italy' (id=18) mando la notifica al responsibile della BU
        if (this.buid == 18) {
          let BUDirectorEmail = await this.getBUDirector(18, 154);
          if (BUDirectorEmail != null && BUDirectorEmail != "") {
            directorEmail = BUDirectorEmail;
            //console.log("directorEmail = BUDirectorEmail")
          }
        }

        //console.log("director email", directorEmail, "legal represetant", this.legalRepresentantEmail, "sendmail", this.sendMail, this.buid);
        this.ConstructEmail(
          Trans.i18n.t("Validations.ValueGuaranteedSubject"),
          Trans.i18n.t("Validations.ValueGuaranteed"),
          [directorEmail, this.legalRepresentantEmail],
          [this.username, process.env.VUE_APP_EMAIL]
        );
        //}

        return true;
      }

      return false;
    },

    CheckWarranty() {
      //   console.log(
      //     "warranty selected",
      //     this.warrantySelected,
      //     this.warrantiesCheck
      //   );

      let warrantyId = this.warrantySelected.id
        ? this.warrantySelected.id
        : this.warrantySelected;

      if (this.warrantiesCheck.indexOf(warrantyId) > -1) {
        // set to "da controllare"
        if (this.forceStatusToBeToValidate()) {
          this.statusSelected = this.statuses.find(
            (x) => x.id == this.statusToBeChecked
          );
        }
        this.dialogMessage = Trans.i18n.t("Validations.Warranty");
        this.dialogHasTobeShown = true;
        this.sendMail = true;

        this.ConstructEmail(
          Trans.i18n.t("Validations.WarrantySubject"),
          Trans.i18n.t("Validations.Warranty"),
          [process.env.VUE_APP_EMAIL],
          []
        );

        // console.log("CheckWarranty true");
        return true;
      }

      return false;
    },

    CheckRefused() {
      //   console.log("CheckRefused true", this.statusSelected);
      let statusSelectedId = this.statusSelected.id
        ? this.statusSelected.id
        : this.statusSelected;
      if (statusSelectedId == this.statusRefused) {
        this.sendMail = true;
        this.ConstructEmail(
          Trans.i18n.t("Validations.RefusedSubject"),
          Trans.i18n.t("Validations.Refused"),
          [this.$GAUserAuth.user.email],
          [process.env.VUE_APP_EMAIL]
        );
        // console.log("CheckRefused true");
        return true;
      }

      return false;
    },

    ConstructEmail(subject, text, tos, ccs) {
      this.mailSubject = subject;
      this.mailText = text;
      this.mailTos = tos;
      this.mailCCs = ccs;
    },

    closeDialog() {
      this.dialog = false;
      router.push({ name: "RequestCompleted" });
    },
  },
};
</script>
